import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ClientService } from './client.service';
import { Client } from './client.model';

@Injectable({ providedIn: 'root' })
export class ClientGuard implements CanActivate {

  constructor(private clientService: ClientService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.clientService.getClient() ? true : false;
  }

}
